const integrationTypes = {
  ZENDESK: 'zendesk',
  WONDERCHAT: 'wonderchat',
  NONE: 'none',
};

export default integrationTypes;
